import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyAudits = lazyWithRetry(() => import("./Audits"));

const Audits = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyAudits {...props} />;

export default Audits;
